import styled, { css } from 'styled-components/macro'

export const Wrap = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: ${(props) => props.theme.color.transparent};
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  &:last-child {
    margin: 0;
  }
`

export const Title = styled.h3`
  margin: 0;
  padding: 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.6rem;
  line-height: 1.33;
  text-align: left;
  color: ${(props) => props.theme.color.text};
  transition: all 0.26s;
`

export const Header = styled.button<{ isOpen?: boolean }>`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;
  color: inherit;
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  transition: all 0.26s;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.transparent};
  cursor: pointer;
  &:focus {
    outline: none;
  }
  ${(props) =>
    !props.isOpen &&
    css`
      &:hover {
        ${Title} {
          transform: translateX(1.2%);
        }
      }
    `}
  ${(props) =>
    props.isOpen &&
    css`
      border-color: ${(props) => props.theme.color.elementBorder};
    `}
  svg {
    transition: transform 0.26s;
    transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
  }
`

export const IconWrap = styled.span`
  margin: 0;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  gap: 0.8rem;
  color: ${(props) => props.theme.color.default};
`

export const ContentWrap = styled.div`
  padding: 0;
  background-color: ${(props) => props.theme.color.transparent};
`

export const Content = styled.div<{ maxHeight?: string }>`
  padding: 1.6rem;
  max-height: ${(props) => props.maxHeight};
  ${(props) =>
    props.maxHeight !== 'fit-content' &&
    css`
      overflow-x: hidden;
      overflow-y: auto;
    `}
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 1.6rem 3.2rem 1.6rem 1.6rem;
  `};
`
